define( 'templates/device-type-templates',['templates/template-builder'], function(TemplateBuilder) {
    var templateBuilder = new TemplateBuilder();
    
    return {
        /**
         * HEADERS -------------------------------------------------------
         */
        'headers' : {
            // Sortable
            'name' : templateBuilder.sortableHeader('name', 'Name', 'nameCI'),
            
            // Basic 
            'description' : templateBuilder.basicHeader('description', 'Description'),
            'keepAlive' : templateBuilder.basicHeader('keepAlive', 'Keep alive'),
            'payloadType' : templateBuilder.basicHeader('payloadType', 'Display type'),
            'dtGroup' : templateBuilder.basicHeader('dtGroup', 'Group'),
            'contracts' : templateBuilder.basicHeader('contracts', 'Contracts'),
            'downlinkData' : templateBuilder.basicHeader('downlinkData', 'Downlink data'),
            'projectId' : templateBuilder.basicHeader('projectId', 'Project ID')
        },
        
        /**
         * DATA TEMPLATES -------------------------------------------------------
         */
        'templates' : {
            'name' : templateBuilder.linkNode( '${url}', '${name}' ),
            'description' : templateBuilder.basicNode( '${description}' ),
            'keepAlive' : templateBuilder.basicNode( '${keepAlive}' ),
            'payloadType' : templateBuilder.basicNode( '${payloadType}' ),
            'dtGroup' : templateBuilder.linkNode( '${groupUrl}', '${groupName}' ),
            'contracts' : function(data) {
            	var ret = {
                    'nodeType':'td',
                    'content': []         
                };
            	
            	var nbIter = Math.min(data.contracts.length, 3);
            	for (var i = 0; i < nbIter; i++) {
            		ret.content.push({
                        'nodeType':'a',
                        'href': data.contracts[i].contractUrl,
                        'content': data.contracts[i].contractName
                    });
            		
            		if (i + 1 < nbIter) {
	            		ret.content.push({
	                        'nodeType': 'span',
	                        'content': ', '
	                    });
            		}
            	}
            	
            	if (nbIter != data.contracts.length) {
            		ret.content.push({
                        'nodeType': 'span',
                        'content': ', ...'
                    });
            	}
            	return ret;
            },
            'downlinkData' : templateBuilder.basicNode( '${downlinkData}' ),
            'projectId' : templateBuilder.basicNode( '${projectId}' )
        } // end templates data
    }; // end return
});

